import React from 'react';
import type {FC} from 'react';
import {Link, Outlet} from 'react-router-dom';
import AuthCarousel from './components/AuthCarousel';
import styles from './AuthRoot2.module.css';
import {logoText} from '../../../assets/images';
import {CookiePrompt} from '../../../modules/CookiePrompt';

const AuthRoot2: FC = () => {
  return (
    <div className={styles.layout}>
      <aside className={styles.left}>
        <div className={styles.container}>
          <Link to="/auth/login">
            <img src={logoText} alt="logo-text" />
          </Link>
          <Outlet />
        </div>
        <CookiePrompt />
      </aside>
      <section className={styles.right}>
        <AuthCarousel />
      </section>
    </div>
  );
};

export default AuthRoot2;
